import React from "react"
import PropTypes from "prop-types"
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts"

export default class DiabetesGraph extends React.Component {
    static propTypes = {
        resources: PropTypes.arrayOf(PropTypes.object),
    }

    getA1cData() {
        const { resources = [] } = this.props

        // 1️⃣ Filter Observation resources
        const observations = resources.filter(
            (r) => r.resource.resourceType === "Observation"
        )

        // 2️⃣ Get only "Hemoglobin A1c/Hemoglobin.total in Blood"
        const a1cObservations = observations.filter((obs) => {
            const codeText =
                obs.resource.code?.text ||
                obs.resource.code?.coding?.[0]?.display ||
                obs.resource.code?.coding?.[0]?.code ||
                ""
            return (codeText.includes("Hemoglobin A1c/Hemoglobin.total in Blood") || codeText.includes("Hemoglobin A1c"))
        })

        console.log("Filtered A1c Observations:", a1cObservations)

        // 3️⃣ Format, sort, and deduplicate
        const formattedData = a1cObservations
            .map((obs) => {
                const value =
                    obs.resource.valueQuantity?.value ||
                    obs.resource.valueString ||
                    parseFloat(obs.resource.valueQuantity?.value) ||
                    null

                const unit =
                    obs.resource.valueQuantity?.unit ||
                    obs.resource.valueQuantity?.code ||
                    "%"

                const date =
                    obs.resource.effectivePeriod?.start ||
                    obs.resource.effectiveDateTime ||
                    obs.resource.issued ||
                    obs.resource.meta?.lastUpdated ||
                    ""

                const formattedDate = new Date(date).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                })

                return {
                    date: formattedDate,
                    value: parseFloat(value),
                    unit,
                    rawDate: new Date(date),
                }
            })
            // ✅ Sort chronologically
            .sort((a, b) => a.rawDate - b.rawDate)

        // 4️⃣ Remove duplicates (same date + same value)
        const uniqueData = formattedData.filter(
            (item, index, self) =>
                index ===
                self.findIndex(
                    (t) => t.date === item.date && t.value === item.value
                )
        )

        // 5️⃣ Add displayDate after sorting and filtering
        const finalData = uniqueData.map((item, index) => ({
            ...item,
            displayDate: `${item.date} #${index + 1}`,
        }))

        return finalData
    }



    render() {
        const data = this.getA1cData()
        console.log("A1c Data:", data)

        if (!data || data.length === 0) {
            return <p>No HbA1c data available.</p>
        }

        return (
            <>
                <h4><strong>A1c Trend</strong></h4>
                <div style={{ width: "100%", height: 300, minWidth: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={data} margin={{ top: 10, right: 30, bottom: 0, left: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis
                                domain={["dataMin - 0.5", "dataMax + 0.5"]}
                                label={{
                                    value: "A1c (%)",
                                    angle: -90,
                                    position: "insideLeft",
                                }}
                            />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="value"
                                stroke="#8884d8"
                                activeDot={{ r: 8 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </>
        )
    }
}
